import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {reaction} from 'mobx'
import Const from '../Const'
import DataTools from '../toolsClass/DataTools'
import EffectTools from '../toolsClass/EffectTools'
import HigherTools from '../toolsClass/HigherTools'
import Input from './Input'

@inject("uiState","appState","inputState")@observer
class InputBinder extends Component {
  lastUrlRef;
  inputRef;
  modifyUrlReaction;
  throttleHandleEnter;
  replyEffectTimer;
  testTime; //测试用
  playQQMusicWindowId = 0
  constructor(props) {
    super(props)
    const higherTools = HigherTools.createHigherToolsClass()
    this.throttleHandleEnter = higherTools.throttle(this.handleEnter, Const.count.enterTime)
    this.modifyUrlReaction = reaction(() => this.props.inputState.clickedUrl,this.replyEffect)
  }
  componentDidMount(){
    const higherTools = HigherTools.createHigherToolsClass()
    const dataTools = DataTools.createDataToolsClass()
    window.onkeydown = this.handleKeyboardEvent
    const value = localStorage.getItem(Const.storageKey.inputValue)
    const valueArray = dataTools.csvToArrayNoEmpty(value)
    this.props.appState.setInputValueList(valueArray)
  }
  componentWillUnmount() {
    this.modifyUrlReaction()
    window.onkeydown = null
  }
  replyEffect = ()=>{
    if (this.props.inputState.clickedUrl === "") {
      return
    }
    if(!Const.asyncInputKey.has(this.props.appState.asyncEffect))
    {
      if(this.replyEffectTimer){
        clearTimeout(this.replyEffectTimer)
      }
      this.replyEffectTimer = setTimeout(()=>{
        this.lastUrlRef.href = this.props.inputState.clickedUrl
        this.lastUrlRef.click()
        this.inputRef.focus()
        this.inputRef.blur()
        this.props.inputState.clickedUrl = ""
        this.replyEffectTimer = null
      },Const.count.newWindowTime)
    }
    else if(this.props.appState.asyncEffect === Const.inputKey.playQQMusic){
      if(this.replyEffectTimer){
        clearTimeout(this.replyEffectTimer)
      }
      this.replyEffectTimer = setTimeout(()=>{
        this.lastUrlRef.href = this.props.inputState.clickedUrl
        if(this.playQQMusicWindowId === 1){
          this.props.appState.playQQMusicWindow.resizeTo(Const.count.playQQMusicWindowWidth,Const.count.playQQMusicWindowHeight)
          this.props.appState.playQQMusicWindow.moveTo((window.screen.width-Const.count.playQQMusicWindowWidth)/2, (window.screen.height-Const.count.playQQMusicWindowHeight)/2)
          this.props.appState.playQQMusicWindow.location.href = this.props.inputState.clickedUrl
        }
        else if(this.playQQMusicWindowId === 2){
          const tempWindow = this.props.appState.playQQMusicOtherWindow
          setTimeout(()=>{
            tempWindow.close()
          }, Const.count.otherWindowDisplayTime)
          this.props.appState.playQQMusicOtherWindow.location.href = this.props.inputState.clickedUrl
        }
        this.props.inputState.clickedUrl = ""
        this.replyEffectTimer = null
      },Const.count.newWindowTime)
    }
    else if(this.props.appState.asyncEffect === Const.inputKey.playQQMusicMv){
      if(this.replyEffectTimer){
        clearTimeout(this.replyEffectTimer)
      }
      this.replyEffectTimer = setTimeout(()=>{
        this.lastUrlRef.href = this.props.inputState.clickedUrl
        this.props.appState.playQQMusicMvWindow.resizeTo(window.screen.width-60,window.screen.height-60)
        this.props.appState.playQQMusicMvWindow.moveTo(30, 30)
        this.props.appState.playQQMusicMvWindow.location.href = this.props.inputState.clickedUrl
        this.props.inputState.clickedUrl = ""
        this.replyEffectTimer = null
      },Const.count.newWindowTime)
    }
  }
  handleKeyboardEvent = (event)=>{
    const keyCode = event.keyCode

    if(keyCode === 13){
      this.throttleHandleEnter()
    }
    else if(keyCode === 38){
      this.handleStorageInputValue(true)
      event.preventDefault()
    }

    else if(keyCode === 40)
    {
      this.handleStorageInputValue(false)
      event.preventDefault()
    }

  }
  handleEnter = ()=>{
    if(this.props.inputState.inputIsFocus && !this.props.inputState.inputIsComposition){
      this.handleInput()
    }
    else{
      this.inputRef.focus()
    }
  }
  handleStorageInputValue = (isUp)=>{
    if(this.props.inputState.inputIsFocus && !this.props.inputState.inputIsComposition){
      this.props.appState.setIuputValueCount(isUp)
      if(this.props.appState.inputValueListValue){
        this.props.inputState.changeInputValue(this.props.appState.inputValueListValue)
      }
      else{
        this.props.inputState.changeInputValue("")
      }
    }
  }
  changeInputValue = (event) => {
    //if(!this.props.inputState.inputIsComposition)
      this.props.inputState.changeInputValue(event.target.value)
  }
  handleInput = (event) => {
    this.testTime = Date.now()
    if(this.props.inputState.inputValue === ""){
      this.inputRef.blur()
      return
    }

    this.props.appState.changeExecuteState(Const.executeKey.doing)
    const dataTools = DataTools.createDataToolsClass()
    const effectTools = EffectTools.createEffectToolsClass()

    dataTools.handleKeyAndStorageWithLocal(this.props.inputState.inputValue,
    Const.storageKey.inputValue,Const.count.storageInputValueCount)
    this.props.appState.pushInputValueList(this.props.inputState.inputValue)
    this.props.appState.setInputValueCountZero()

    const standardInput = dataTools.convertInputToObject(this.props.inputState.inputValue)
    const standardInputWithEffect = dataTools.addEffectToStandardInput(
      standardInput, this.props.appState.defaultValue
    )
    this.props.appState.setAsyncEffect(standardInputWithEffect.effect)
    const effect = effectTools.switchInputToEffect(standardInputWithEffect)
    if(Const.asyncInputKey.has(this.props.appState.asyncEffect)){
      if(standardInput.arguments.length !== 0)
        this.handleAsyncWindow()
      this.handleAsyncEffect(effect)
    }
    else
      this.handleEffect(effect)
    this.props.inputState.changeInputValue("")
    this.inputRef.blur()
    this.props.uiState.setInputA(Const.text.get("input2"))
  }
  handleEffect=(effect)=>{
    if(effect.state === Const.executeKey.error || effect.url === null || effect.url === "")
    {
      if(effect.state === Const.executeKey.success)
      {
        this.props.appState.changeExecuteState(Const.executeKey.success)
      }
      else {
        this.props.appState.changeExecuteState(Const.executeKey.error)
      }

    }
    else if (effect.state === Const.executeKey.warning) {
      this.props.inputState.changeClickedUrl(effect.url)
      this.props.appState.changeExecuteState(Const.executeKey.warning)
    }
    else if (effect.state === Const.executeKey.success) {
      this.props.inputState.changeClickedUrl(effect.url)
      this.props.appState.changeExecuteState(Const.executeKey.success)
    }
    else{
      this.props.appState.changeExecuteState(Const.executeKey.error)
    }
    if(this.props.appState.asyncEffect === Const.inputKey.clear ||
    this.props.appState.asyncEffect === Const.inputKey.clearInput){
      this.props.appState.setInputValueList([])
    }
  }
  handleAsyncEffect = (effect)=>{
    if(effect.state === Const.executeKey.error){
      this.props.appState.changeExecuteState(Const.executeKey.error)
      return
    }
    const dataTools = DataTools.createDataToolsClass()
    effect.then((data)=>{
      const state = dataTools.convertAsyncDataToEffect(data)
      if(state.url === ""){
        this.props.appState.changeExecuteState(Const.executeKey.error)
      }
      else if(state.errorInfo.length !== 0){
        console.log(Date.now()-this.testTime)
        this.props.appState.changeExecuteState(Const.executeKey.warning)
        this.props.inputState.changeClickedUrl(state.url)
      }
      else {
        console.log(Date.now()-this.testTime)
        this.props.appState.changeExecuteState(Const.executeKey.success)
        this.props.inputState.changeClickedUrl(state.url)
      }
      this.props.appState.changeExecuteErrorInfo(state.errorInfo)
      dataTools.handleKeyAndStorageWithSession(state.keys, this.props.appState.asyncEffect,
         Const.count.storageSongCount, false)
    })
  }
  handleAsyncWindow = ()=>{
    const {playQQMusicWindow} = this.props.appState
    const effectTools = EffectTools.createEffectToolsClass()
    if(this.props.appState.asyncEffect === Const.inputKey.playQQMusic){
      if(playQQMusicWindow === null || playQQMusicWindow.closed){
        const tempWindow = window.open("",effectTools.randomStringkBuilder(30),
      `channelmode=0,directories=0,fullscreen=0,height=120,left=75,location=0,menubar=0,resizable=1,scrollbars=0,status=0,titlebar=0,toolbar=0,top=${window.screen.height/2},width=160`)
        this.props.appState.setPlayQQMusicWindow(tempWindow)
        this.playQQMusicWindowId = 1
      }
      else{
        const tempWindow = window.open("",effectTools.randomStringkBuilder(30),
      `channelmode=0,directories=0,fullscreen=0,height=120,left=75,location=0,menubar=0,resizable=1,scrollbars=0,status=0,titlebar=0,toolbar=0,top=${window.screen.height/2},width=160`)
        this.props.appState.setPlayQQMusicOtherWindow(tempWindow)
        this.playQQMusicWindowId = 2
      }
    }
    else if(this.props.appState.asyncEffect === Const.inputKey.playQQMusicMv){
      let tempWindow = window.open("",effectTools.randomStringkBuilder(30),
    `channelmode=0,directories=0,fullscreen=0,height=120,left=75,location=0,menubar=0,resizable=1,scrollbars=0,status=0,titlebar=0,toolbar=0,top=${window.screen.height/2},width=160`)
      this.props.appState.setPlayQQMusicMvWindow(tempWindow)
    }
  }
  getLastUrlRef = (a) => {
    this.lastUrlRef = a
  }
  getInputRef = (input)=>{
    this.inputRef = input
  }
  inputOnFocus = (event)=>{
    this.props.inputState.switchInputFocus(true)
  }
  inputOnBlur = (event)=>{
    this.props.inputState.switchInputFocus(false)
  }
  inputOnCompositionStart = (event)=>{
    this.props.inputState.switchInputComposition(true)
  }
  inputOnCompositionEnd = (event)=>{
    this.props.inputState.switchInputComposition(false)
  }
  turnIntoBlur = (event)=>{
    event.target.blur()
  }
  render() {
    const {loadingStyle,inputButtonStyle,inputA} = this.props.uiState
    const {inputValue} = this.props.inputState
    const higherTools = HigherTools.createHigherToolsClass()
    const props = {
      getLastUrlRef: this.getLastUrlRef,
      getInputRef: this.getInputRef,
      input: inputA,
      submit: Const.text.get("submit"),
      handleInput: higherTools.throttle(this.handleInput,Const.count.handleInputTime),
      changeInputValue: this.changeInputValue,
      inputValue: inputValue,
      loadingStyle: Const.defaultStyle.get(loadingStyle),
      inputButtonStyle: Const.defaultStyle.get(inputButtonStyle),
      inputOnFocus: this.inputOnFocus,
      inputOnBlur: this.inputOnBlur,
      turnIntoBlur: this.turnIntoBlur,
      inputOnCompositionStart: this.inputOnCompositionStart,
      inputOnCompositionEnd: this.inputOnCompositionEnd
    }
    return <Input {...props}></Input>
  }
}
export default InputBinder



// WEBPACK FOOTER //
// ./src/textModule/InputBinder.js